import React from 'react';
import CalcUI from '../CalcUi';

import './main.css';

const Main: React.FC = () => {
  return (
    <div id="calc-container">
      <CalcUI />
    </div>
  );
};

export default Main;
